<template>
  <template v-if="showLink">
    <router-link
      :to="{
        name: 'search-result',
        query: {
          q: props?.text?.name,
          type: 'activities',
        },
      }"
      v-if="!loading"
    >
      <div
        class="flex px-8 items-center justify-center h-24 w-fit-content"
        :class="[version === 'primary' ? '' : 'bd-1 bd-blue-dark']"
      >

        <img
          :src="`${ASSETS_CDN}/icons/new_activities/${props?.text?.code}.svg`"
          alt=""
          class="w-24 h-24 mr-8"
        />
        <p
          class="mb-0 fs-14 lh-18 black "
          :class="[version === 'primary' ? '' : 'blue-dark']"
        >{{ props?.text?.name }}</p>
      </div>
    </router-link>
    <SkeletonLoading
      v-else
      :height="'26px'"
      :width="randomWidth"
      :border-radius="'1000px'"
    />
  </template>
  <template v-else>
    <div class="flex px-8 items-center justify-center h-24 w-fit-content"
         :class="[version === 'primary' ? '' : 'bd-1 bd-blue-dark br-999 bg-green-light']"
    >
      <img
        :src="`${ASSETS_CDN}/icons/new_activities/${props?.text?.code}.svg`"
        alt=""
        class="w-18 h-18 mr-8"
      />
      <p
        class="mb-0 fs-14 lh-18 "
        :class="[version === 'primary' ? 'black' : 'blue-dark white-space']"
      >{{ props?.text?.name }}</p>
    </div>
  </template>
</template>

<script setup>
import SkeletonLoading from '~/components/globals/Loading/SkeletonLoading.vue'
import { computed } from 'vue'
import {assetCDN, getRandomArbitrary} from '~/helper'

const props = defineProps({
  text: {
    type: Object,
    default: () => {},
  },
  loading: {
    type: Boolean,
    default: false,
  },
  showLink: {
    type: Boolean,
    default: true,
  },
  version: {
    type: String,
    required: false,
    default: 'primary',
  },
})

// const map = {
//   Adventure: 'adventure',
//   'Beach & Sea': 'beach',
//   Cruising: 'cruising',
//   Cycling: 'cycling',
//   'Culture & Arts': 'culturearts',
//   Diving: 'diving',
//   'Outdoors & Nature': 'outdoors',
//   'Food & Drink': 'food',
//   Motorcycling: 'motorcycling',
//   Relaxation: 'relaxation',
//   Skiing: 'skiing',
//   'Hiking & Trekking': 'hiking',
//   Sightseeing: 'sightseeing',
//   Golfing: 'golfing',
//   More: 'more',
//   Wellness: 'wellness',
//   'Community Giving': 'community-giving'
// }

const randomWidth = computed(() => `${getRandomArbitrary(50, 175)}px`)

const ASSETS_CDN = assetCDN()
</script>

<style lang="scss" scoped></style>
